import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Filter = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 12 10"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M0 1H12M2 5H10M4 9H8" />
    </svg>
  ),
)
Filter.displayName = 'Filter'
Filter.defaultProps = {
  width: 12,
  height: 10,
}

export default Filter
